<template>
  <main class="coordinate-guide-page">
    <header class="guide-header">
      <button type="button" aria-label="返回" @click="goBack">‹</button>
      <div>
        <span>备用选点方式</span>
        <h1>地址搜索不可用时怎么办？</h1>
      </div>
    </header>

    <section class="guide-card guide-card--intro">
      <div class="guide-icon">⌖</div>
      <div>
        <strong>使用坐标仍然可以定位</strong>
        <p>当地点搜不到、搜索接口繁忙或额度不足时，可以先取得目标位置的经纬度，再粘贴回地图搜索框。</p>
      </div>
    </section>

    <section class="guide-card steps-card">
      <div class="step-item">
        <b>1</b>
        <div><strong>打开坐标拾取器</strong><p>点击下方按钮，在高德坐标拾取器中找到目标位置。</p></div>
      </div>
      <div class="step-item">
        <b>2</b>
        <div><strong>复制坐标</strong><p>点击地图目标点，复制“经度,纬度”，例如 116.397428,39.909230。</p></div>
      </div>
      <div class="step-item">
        <b>3</b>
        <div><strong>粘贴并搜索</strong><p>返回地图，把坐标直接粘贴到顶部搜索框并点击“搜索”。页面会自动识别，不需要切换模式。</p></div>
      </div>
      <div class="step-item">
        <b>4</b>
        <div><strong>确认并锁定</strong><p>确认红色准星位置正确后，点击底部“锁定”即可。</p></div>
      </div>
    </section>

    <section class="tip-card">
      <strong>坐标格式提示</strong>
      <p>支持英文逗号、中文逗号或空格分隔，也支持“纬度,经度”的复制顺序。建议使用高德 GCJ-02 坐标。</p>
    </section>

    <a class="picker-button" href="https://lbs.amap.com/tools/picker" target="_blank" rel="noopener noreferrer">
      打开高德坐标拾取器
    </a>
  </main>
</template>

<script>
export default {
  name: 'IphonLocalCoordinateGuide',
  methods: {
    goBack() {
      if (window.opener) {
        window.close()
        return
      }
      this.$router.push('/iphon-seting/map')
    },
  },
}
</script>

<style scoped>
.coordinate-guide-page {
  min-height: 100vh;
  min-height: 100dvh;
  padding: calc(18px + env(safe-area-inset-top)) 16px calc(24px + env(safe-area-inset-bottom));
  background: linear-gradient(180deg, #eef7ff 0%, #f8fbff 46%, #f3f7fb 100%);
  color: #17243a;
  box-sizing: border-box;
}
.guide-header { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; }
.guide-header button {
  width: 42px; height: 42px; flex: 0 0 42px; padding: 0 0 4px; border: 0; border-radius: 50%;
  background: #fff; box-shadow: 0 8px 22px rgba(44, 83, 124, .12); color: #1e5f9d; font-size: 31px;
}
.guide-header span { color: #4e83b5; font-size: 12px; font-weight: 700; }
.guide-header h1 { margin: 3px 0 0; font-size: 22px; line-height: 1.25; }
.guide-card, .tip-card {
  margin-bottom: 14px; padding: 17px; border: 1px solid rgba(124, 174, 219, .2); border-radius: 20px;
  background: rgba(255, 255, 255, .94); box-shadow: 0 12px 30px rgba(52, 91, 132, .09);
}
.guide-card--intro { display: flex; gap: 13px; align-items: flex-start; }
.guide-icon {
  display: grid; place-items: center; width: 44px; height: 44px; flex: 0 0 44px; border-radius: 14px;
  background: #e9f5ff; color: #1684e8; font-size: 26px;
}
.guide-card strong, .tip-card strong { font-size: 16px; }
.guide-card p, .tip-card p { margin: 6px 0 0; color: #64758a; font-size: 13px; line-height: 1.65; }
.steps-card { padding: 7px 17px; }
.step-item { display: flex; gap: 12px; padding: 14px 0; border-bottom: 1px solid #edf2f7; }
.step-item:last-child { border-bottom: 0; }
.step-item b {
  display: grid; place-items: center; width: 28px; height: 28px; flex: 0 0 28px; border-radius: 50%;
  background: #1684e8; color: #fff; font-size: 13px;
}
.step-item div { min-width: 0; }
.step-item strong { font-size: 15px; }
.step-item p { margin-top: 4px; }
.tip-card { background: #fff8e9; border-color: #ffe0aa; }
.tip-card strong { color: #a35b08; }
.tip-card p { color: #806442; }
.picker-button {
  display: flex; align-items: center; justify-content: center; min-height: 50px; border-radius: 16px;
  background: #1684e8; box-shadow: 0 12px 25px rgba(22, 132, 232, .22); color: #fff;
  font-size: 15px; font-weight: 700; text-decoration: none; touch-action: manipulation;
}
</style>
